// extracted by mini-css-extract-plugin
export default {"title":"title-view_title__aC1C+"};